import { TextInput } from '@mantine/core';
import * as Icon from '@tabler/icons-react';
import './styles.scss';
interface InputsProps {
  label: string;
  value: string | number;
  onClick?: () => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  isEditable?: boolean;
  search?: () => void;
  onDelete?: () => void;
  showName?: boolean;
  placeholder?: string;
}

const Input = ({
  label,
  value,
  onChange,
  disabled,
  isEditable = false,
  search,
  onDelete,
  showName = true,
  placeholder
}: InputsProps) => {
  const displayValue = showName ? value : String(value);

  return (
    <TextInput
      label={label}
      value={displayValue}
      placeholder={placeholder}
      onChange={isEditable && onChange ? onChange : undefined}
      disabled={disabled}
      readOnly={!isEditable || !onChange}
      className="custom-input"
      rightSection={
        isEditable ? (
          <div className="icon-wrapper">
            {search && <Icon.IconSearch className="input-icon" stroke={2} onClick={search} />}
            {onDelete && <Icon.IconX className="input-icon" stroke={2} onClick={onDelete} />}
          </div>
        ) : null
      }
    />
  );
};
export default Input;
